import request from '../utils'

const evaluationApi = {
    evaluationList: async (modelingId) => {
        const req = request.get(`/api/modeling/${modelingId}/evaluation`)
        const res = await req;
        return res.body;
    }, 
    evaluationListByKpi: async (modelingId, kpiId) => {
        const req = request.get(`/api/modeling/${modelingId}/evaluation/bykpi/${kpiId}`)
        const res = await req;
        return res.body;
    }, 
    evaluationDetail: async (modelingId, evaluation) => {
        const req = request.get(`/api/modeling/${modelingId}/evaluation/${evaluation}`)
        const res = await req;
        return res.body;
    },
    evaluationUpdate: async (modelingId, evaluation) => {
        const req = request.put(`/api/modeling/${modelingId}/evaluation/${evaluation.id}`).send(evaluation);
        const res = await req;
        return res.body;
    },
    evaluationCreate: async (modelingId, evaluation) => {
        const req = request.post(`/api/modeling/${modelingId}/evaluation`).send(evaluation);
        const res = await req;
        return res.body;
    },
    evaluationDelete: async (modelingId, evaluationId) => {
        const req = request.delete(`/api/modeling/${modelingId}/evaluation/${evaluationId}/force`);
        await req;
    }
};

export default evaluationApi